import React from 'react';
import { Card, Typography, Box, styled } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import { useSelector } from 'react-redux';
import { selectTopFiveChartData } from "../../redux-store/dashboardSlice/dashboardSliceSelectors";
import { WrapText } from '@mui/icons-material';

const ChartContainer = styled(Box)({
    flexGrow: 1,
    height: "340px",
    overflow: 'visible',  
});

export const TopFiveBlock = () => {
    const chartData = useSelector((state) => selectTopFiveChartData(state));
    if (!chartData) return null;

    //const xLabels = chartData.map(c =>c.courseName.split(" ")); // split words
    const xLabels = chartData.map((x) => x.courseName);
    const values = chartData.map((x) => x.percentage);

    console.log("xLabels", xLabels);

    return (
        <Card sx={{ height: 460, display: "flex", flexDirection: "column"}}>
           <Box p={2} sx={{ height: '100%', overflow: 'visible'}}>
                <Typography variant="h6" fontWeight={600} textAlign="center" sx={{ mb: 1 }}>
                    Courses Progress
                </Typography>
                <Box mt={1} flexGrow={1} position="relative" >
                    <ChartContainer sx={{ marginBottom: '20px' }}>
                        <BarChart
                            grid={{ horizontal: true }}
                            series={[
                                {
                                    data: values, // just numbers
                                    label: 'Completion %',
                                    valueFormatter: (v) => `${v}%`,
                                    // **IMPORTANT: Directly apply per-bar colors** by using `barColors`
                                    //   barColors: chartData.map((_, idx) => getColor(idx)), // Assign color to each bar                                  
                                },
                            ]}
                            xAxis={[
                                {
                                    data: xLabels, // course names                                    
                                    scaleType: 'band',
                                    colorMap: { type: 'ordinal', colors: ['rgb(231,179,11)', '#ef5350', '#29b6f6', 'purple', 'orange', 'green', 'teal'], },
                                    valueFormatter: (value) => value.split(" ").join("\n"), 
                                    tickLabelStyle: {
                                        angle: 55,
                                        textAnchor: 'start',
                                        fontSize: 11,
                                        lineHeight: 1.0,
                                    },                                                                                                                                                                                                                                
                                },
                                
                            ]}
                            margin={{ bottom: 100 }}
                            tooltip={{
                                trigger: 'axis',
                            }}                            
                            
                            sx={{
                                height: '400',                                
                            }}
                            slotProps={{
                                legend: { hidden: true },
                            }}
                        />
                    </ChartContainer>
                </Box>
            </Box>
        </Card>
    );
};

// Function to return unique colors for each bar based on index
const getColor = (index) => {
    const colors = [
        'rgb(231,179,11)', // yellow
        '#ef5350', // red
        '#29b6f6', // blue
        'purple', // purple
        'orange', // orange
        'green', // green
        'teal', // teal
    ];
    return colors[index % colors.length];
};